import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import strings from "../../config/localization";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import RoleRemove from "./RoleRemove";
import { useNavigate } from "react-router-dom";
import { useGetRolesByUserIdQuery } from "../../services/appln";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import AddButton from "../../components/Buttons/AddButton";
import Button from "@mui/material/Button";
import { getRowsPerPage } from "../constants";

export default function RolePanel(props: {
  userId: string;
  showBackButton: boolean;
}) {
  const navigate = useNavigate();

  const userId = props.userId;

  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());

  const getParams = {
    userId: userId,
    page: count,
    limit: rowPerPage,
    search: "",
  };

  const { data, error, isLoading, isFetching } =
    useGetRolesByUserIdQuery(getParams);

  const columns = [
    {
      field: "name",
      headerName: strings.name,
      width: 300,
    },
    {
      field: "delete",
      headerName: "",
      width: 150,
      renderCell: (params: any) => (
        <RoleRemove userId={userId} roleId={params.id} />
      ),
    },
  ];

  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isLoading || isFetching ? (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : null}
          </Grid>
          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>{strings.error}</AlertTitle>
                {strings.failedToLoadRoles}
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom component="div">
                  {" "}
                  {strings.roles}{" "}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <AddButton
                  onClickHandler={() => {
                    navigate(`../selectRoles/${userId}`);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={data?.data ? data?.data : []}
                columns={columns}
                checkboxSelection={false}
              />
              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
          {props.showBackButton ? (
            <Grid item xs={12}>
              <Button
                variant="contained"
                onClick={(e) => {
                  e.preventDefault();
                  navigate(-1);
                }}
              >
                {strings.back}
              </Button>
            </Grid>
          ) : null}
        </Grid>
      </Box>
    </div>
  );
}
